import { SubcategoryPicker } from './transition-events-section';

/**
 * Single-select "which sub-category across the whole queue has this flag" picker — used for the
 * Doctor-waiting stage and Consultation stage pickers above the swimlane list. Thin wrapper around
 * the same lane › sub-category picker used by the Transition events tab, but scoped to one
 * boolean flag (e.g. `isDoctorWaitingStage`) instead of the free-form event-key selection.
 *
 * Only one sub-category in the entire draft may have `flagKey: true` at a time — picking a new one
 * clears the flag on every other sub-category (radio-button semantics), and the empty state shows
 * "None selected".
 */
export function StagePicker({ label, hint, swimlanes, flagKey, disabled = false, onSelect }) {
  let laneId = null;
  let subId = null;
  for (const lane of swimlanes) {
    const sub = (lane.subCategories || []).find((s) => Boolean(s[flagKey]));
    if (sub) {
      laneId = lane.id;
      subId = sub.id;
      break;
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="w-48 shrink-0">
        <div className="text-[12.5px] font-semibold text-foreground">{label}</div>
        {hint ? <div className="text-[11px] text-muted-foreground">{hint}</div> : null}
      </div>
      <SubcategoryPicker
        swimlanes={swimlanes}
        value={{ laneId, subId }}
        disabled={disabled}
        allowNone
        noneLabel="None selected"
        onChange={({ laneId: newLaneId, subId: newSubId }) => onSelect(newLaneId, newSubId)}
      />
    </div>
  );
}
